/**
 * Venice Press — Hover-to-Play Video on Product Cards  (v17)
 *
 * v17 — Add hover-video support for Featured Tees section on homepage.
 *   - New setupFeaturedCard() handles simpler .vp-featured-tees__card elements
 *   - getHandleFromHref() extracts product handle from card's own href
 *   - No slideshow/arrow/MutationObserver needed for featured tees cards
 *
 * v16 — Nuclear option: show video IMMEDIATELY on DOM append.
 *   - Previous versions tried 5+ strategies to detect "video is ready"
 *     before showing it. All had race conditions. New approach: show the
 *     video the instant it's appended to the DOM. If still buffering,
 *     user sees frame 1 briefly, then it starts — much better than
 *     the video never appearing at all.
 *   - Simplified startVideo: append → show → play → background retry loop
 *   - ensurePlaying() retries play() every 200ms for 2s if video stalls
 *
 * v12 — Full rewrite to fix perma-loop and inconsistent activation:
 *
 *  PROBLEMS IN v11:
 *    1. Perma-loop: videos keep playing after roll-off because pointerleave
 *       sometimes doesn't fire (fast mouse, browser bugs). Watchdog at 200ms
 *       too slow to catch it.
 *    2. Inconsistent activation: stopImmediatePropagation on pointerenter
 *       blocks theme handlers, complex state machine gets stuck.
 *    3. applyNoOps can race with theme re-initialization.
 *
 *  v12 APPROACH — Simplify everything:
 *    - Use mouseenter/mouseleave on cardContent (don't bubble, reliable)
 *    - Single boolean hovered flag per card, no state machine
 *    - Watchdog every 100ms, aggressively checks pointer position
 *    - mouseout as extra safety net for fast mouse movement
 *    - Generation counter on fetches to prevent stale callbacks
 *    - No stopImmediatePropagation — let theme handlers run
 *    - MutationObserver still handles arrow navigation
 */
(function () {
  'use strict';

  var VP_VERSION = 17;
  if (window.__vpVideoHoverVersion && window.__vpVideoHoverVersion >= VP_VERSION) return;
  var olderVersionRan = !!window.__vpVideoHoverVersion;
  window.__vpVideoHoverVersion = VP_VERSION;

  var videoUrlCache = {};
  var pendingFetches = {};
  var initialized = window.__vpInitialized || {};
  window.__vpInitialized = initialized;
  var cardStates = window.__vpCardStates || [];
  window.__vpCardStates = cardStates;

  // If older version ran, clean up any stuck cards
  if (olderVersionRan) {
    for (var ci = 0; ci < cardStates.length; ci++) {
      forceHide(cardStates[ci]);
    }
    cardStates.length = 0;
    initialized = {};
    window.__vpInitialized = initialized;
  }

  var ptrX = -1;
  var ptrY = -1;

  function getHandle(card) {
    var link = card.querySelector('.card-gallery a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var parts = href.split('/products/');
    if (parts.length < 2) return null;
    return parts[1].split('?')[0] || null;
  }

  function getHandleFromHref(href) {
    var parts = href.split('/products/');
    if (parts.length < 2) return null;
    return parts[1].split('?')[0].split('#')[0] || null;
  }

  function fetchVideoUrl(handle, cb) {
    if (videoUrlCache[handle] !== undefined) {
      cb(videoUrlCache[handle]);
      return;
    }
    if (pendingFetches[handle]) {
      pendingFetches[handle].push(cb);
      return;
    }
    pendingFetches[handle] = [cb];
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (product) {
        var media = product.media || [];
        var vid = null;
        for (var i = 0; i < media.length; i++) {
          if (media[i].media_type === 'video') { vid = media[i]; break; }
        }
        var url = null;
        if (vid && vid.sources) {
          for (var j = 0; j < vid.sources.length; j++) {
            var s = vid.sources[j];
            if (s.format === 'mp4' && s.height <= 480) { url = s.url; break; }
          }
          if (!url) {
            for (var k = 0; k < vid.sources.length; k++) {
              if (vid.sources[k].format === 'mp4') { url = vid.sources[k].url; break; }
            }
          }
        }
        videoUrlCache[handle] = url;
        var cbs = pendingFetches[handle] || [];
        delete pendingFetches[handle];
        for (var c = 0; c < cbs.length; c++) cbs[c](url);
      })
      .catch(function () {
        videoUrlCache[handle] = null;
        var cbs = pendingFetches[handle] || [];
        delete pendingFetches[handle];
        for (var c = 0; c < cbs.length; c++) cbs[c](null);
      });
  }

  // Hide video instantly — no transition delay
  function hideVideo(gallery) {
    var video = gallery.querySelector('.vp-hover-video');
    if (video) {
      video.style.transition = 'none';
      video.pause();
      video.currentTime = 0;
      video.style.opacity = '0';
      video.style.visibility = 'hidden';
      void video.offsetHeight; // force reflow
      video.style.transition = '';
    }
  }

  function showVideo(video) {
    video.style.opacity = '1';
    video.style.visibility = 'visible';
  }

  // Force hide + reset all state for a card
  function forceHide(cs) {
    hideVideo(cs.gallery);
    cs.hovered = false;
    cs.browsing = false;
    cs.browseIndex = 0;
    cs.videoStarting = false;
    cs.hoverGen++;
  }

  function safeSelect(slideshow, index) {
    if (!slideshow || typeof slideshow.select !== 'function') return;
    try { slideshow.select(index); } catch (e) {}
  }

  function getActiveSlideIndex(slideshow) {
    if (!slideshow) return 0;
    var slides = slideshow.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].getAttribute('aria-hidden') === 'false') return i;
    }
    return 0;
  }

  // ---- Pointer tracking ----
  document.addEventListener('pointermove', function (e) {
    ptrX = e.clientX;
    ptrY = e.clientY;
  }, { passive: true });

  // ---- WATCHDOG — 100ms, aggressive ----
  if (window.__vpWatchdogTimer) clearInterval(window.__vpWatchdogTimer);

  window.__vpWatchdogTimer = setInterval(function () {
    for (var i = 0; i < cardStates.length; i++) {
      var cs = cardStates[i];
      if (!cs.hovered && !cs.browsing) continue;

      // Check 1: Is the pointer actually over this card?
      if (ptrX >= 0) {
        var el = document.elementFromPoint(ptrX, ptrY);
        if (!el || !cs.cardContent.contains(el)) {
          forceHide(cs);
          if (cs.slideshow && cs.browseIndex !== 0) {
            safeSelect(cs.slideshow, 0);
          }
          continue;
        }
      }

      // Check 2: Is a video playing but hidden by CSS? (belt + suspenders)
      // SKIP this check if videoStarting — the video was just created and
      // play() was called, but tryShow hasn't fired yet. Killing it here
      // was causing the "loads first frame and hangs" bug.
      if (!cs.videoStarting) {
        var video = cs.gallery.querySelector('.vp-hover-video');
        if (video && !video.paused) {
          var style = window.getComputedStyle(video);
          if (style.opacity === '0' || style.visibility === 'hidden') {
            video.pause();
            video.currentTime = 0;
            cs.hovered = false;
            cs.browsing = false;
          }
        }
      }
    }
  }, 100);

  // ---- Scroll cleanup ----
  var scrollThrottled = false;
  function onScroll() {
    if (scrollThrottled) return;
    scrollThrottled = true;
    setTimeout(function () {
      scrollThrottled = false;
      if (ptrX < 0) return;
      for (var i = 0; i < cardStates.length; i++) {
        var cs = cardStates[i];
        if (!cs.hovered && !cs.browsing) continue;
        var el = document.elementFromPoint(ptrX, ptrY);
        if (!el || !cs.cardContent.contains(el)) {
          forceHide(cs);
          if (cs.slideshow && cs.browseIndex !== 0) {
            safeSelect(cs.slideshow, 0);
          }
        }
      }
    }, 60);
  }
  window.addEventListener('scroll', onScroll, { passive: true, capture: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  // ---- Visibility change — pause everything ----
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      for (var i = 0; i < cardStates.length; i++) forceHide(cardStates[i]);
    }
  }, false);

  // ---- Per-card setup ----
  if (olderVersionRan) return;

  function suppressThemeHover(productCard, slideshow) {
    // Suppress the theme's own hover preview which conflicts with our video
    if (productCard) {
      if (typeof productCard.previewImage === 'function') productCard.previewImage = function () {};
      if (typeof productCard.resetImage === 'function') productCard.resetImage = function () {};
    }
    if (slideshow) {
      if (typeof slideshow.previewImage === 'function') slideshow.previewImage = function () {};
      // Do NOT override slideshow.next / slideshow.previous — that breaks arrow nav
    }
  }

  function ensurePlaying(video, cs, gen) {
    // Retry play() up to 5 times over 2s if the video stalls
    var attempts = 0;
    var timer = setInterval(function () {
      attempts++;
      if (cs.hoverGen !== gen || attempts > 10) {
        clearInterval(timer);
        cs.videoStarting = false;
        return;
      }
      if (!video.paused && video.currentTime > 0) {
        // Actually playing — done
        clearInterval(timer);
        cs.videoStarting = false;
        return;
      }
      // Still not playing — retry
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    }, 200);
  }

  function startVideo(cs, handle) {
    var gallery = cs.gallery;
    var gen = cs.hoverGen;

    var video = gallery.querySelector('.vp-hover-video');
    if (video) {
      showVideo(video);
      video.muted = true;
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      return;
    }

    fetchVideoUrl(handle, function (url) {
      // Stale callback check: if generation changed, user already left
      if (!url || cs.hoverGen !== gen || !cs.hovered) return;

      video = document.createElement('video');
      video.className = 'vp-hover-video';
      video.src = url;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');

      cs.videoStarting = true;

      // Show the video IMMEDIATELY when appended — don't wait for
      // play/canplay/playing/timeupdate/anything. If the video is
      // still buffering, user sees frame 1 briefly, then it starts.
      // This is infinitely better UX than the video never appearing.
      gallery.appendChild(video);
      showVideo(video);

      // Now get it playing — and retry if it stalls
      var p = video.play();
      if (p && p.then) {
        p.then(function () {
          cs.videoStarting = false;
        }).catch(function () {
          // Autoplay blocked — retry muted
          video.muted = true;
          var retry = video.play();
          if (retry && retry.catch) retry.catch(function () {});
        });
      }

      // Background retry loop in case play() hangs or stalls
      ensurePlaying(video, cs, gen);
    });
  }

  function setupCard(cardContent) {
    var gallery = cardContent.querySelector('.card-gallery');
    if (!gallery) return;

    var handle = getHandle(cardContent);
    if (!handle) return;

    var key = handle + '-' + (gallery.getAttribute('data-product-id') || '');
    if (initialized[key]) return;
    initialized[key] = true;

    var slideshow = gallery.querySelector('slideshow-component');
    var productCard = cardContent.closest('product-card');

    // Suppress theme hover at multiple timings to catch late initialization
    suppressThemeHover(productCard, slideshow);
    setTimeout(function () { suppressThemeHover(productCard, slideshow); }, 500);
    setTimeout(function () { suppressThemeHover(productCard, slideshow); }, 1500);
    setTimeout(function () { suppressThemeHover(productCard, slideshow); }, 3000);

    var cs = {
      gallery: gallery,
      cardContent: cardContent,
      slideshow: slideshow,
      hovered: false,    // is the mouse over this card?
      browsing: false,   // did user click an arrow (video hidden, browsing slides)?
      browseIndex: 0,
      hoverGen: 0,       // generation counter — increments on each leave
      videoStarting: false, // true while video is loading/starting — watchdog must not kill it
    };
    cardStates.push(cs);

    // ---- MutationObserver for arrow navigation ----
    // When slide navigation happens while video is showing, hide video + browse.
    // SKIP during videoStarting — the theme slideshow may react to the new
    // video element being added to the DOM by shuffling aria-hidden attributes,
    // which would falsely trigger browse mode before the video even shows.
    if (slideshow) {
      new MutationObserver(function () {
        if (cs.hovered && !cs.browsing && !cs.videoStarting) {
          // Slide changed while video was showing — switch to browse mode
          hideVideo(gallery);
          cs.browsing = true;
          cs.browseIndex = getActiveSlideIndex(slideshow);
        }
      }).observe(slideshow, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
        subtree: true
      });
    }

    // ---- MOUSEENTER on cardContent ----
    // mouseenter doesn't bubble, fires once when pointer enters the element.
    // This is our primary "user is hovering" signal.
    cardContent.addEventListener('mouseenter', function () {
      // Reset any other card that might still be active
      for (var i = 0; i < cardStates.length; i++) {
        if (cardStates[i] !== cs && (cardStates[i].hovered || cardStates[i].browsing)) {
          forceHide(cardStates[i]);
          if (cardStates[i].slideshow && cardStates[i].browseIndex !== 0) {
            safeSelect(cardStates[i].slideshow, 0);
          }
        }
      }

      cs.hovered = true;
      cs.browsing = false;
      cs.browseIndex = 0;
      startVideo(cs, handle);
    }, false);

    // ---- MOUSELEAVE on cardContent ----
    // Primary "user left" signal. mouseleave doesn't bubble.
    cardContent.addEventListener('mouseleave', function () {
      if (cs.browsing && cs.slideshow && cs.browseIndex !== 0) {
        safeSelect(cs.slideshow, 0);
      }
      forceHide(cs);
    }, false);

    // ---- MOUSEOUT as extra safety net ----
    // mouseout fires when pointer leaves ANY child. We check if it left
    // the cardContent entirely (relatedTarget is outside).
    cardContent.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget || !cardContent.contains(e.relatedTarget)) {
        if (cs.hovered || cs.browsing) {
          if (cs.browsing && cs.slideshow && cs.browseIndex !== 0) {
            safeSelect(cs.slideshow, 0);
          }
          forceHide(cs);
        }
      }
    }, false);

    // ---- POINTERLEAVE as another backup ----
    // Some browsers fire pointerleave more reliably in certain edge cases
    cardContent.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.relatedTarget && cardContent.contains(e.relatedTarget)) return;
      if (cs.hovered || cs.browsing) {
        if (cs.browsing && cs.slideshow && cs.browseIndex !== 0) {
          safeSelect(cs.slideshow, 0);
        }
        forceHide(cs);
      }
    }, false);

    // ---- ARROW CLICKS ----
    gallery.addEventListener('click', function (e) {
      var btn = e.target.closest('.slideshow-control--next, .slideshow-control--previous');
      if (!btn) return;

      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();

      var isNext = btn.classList.contains('slideshow-control--next');
      var slideCount = slideshow ? slideshow.querySelectorAll('slideshow-slide').length : 0;
      if (slideCount === 0) return;

      if (cs.hovered && !cs.browsing) {
        // Currently showing video — hide it and start browsing
        hideVideo(gallery);
        cs.browsing = true;
        if (isNext) {
          cs.browseIndex = 1;
          safeSelect(slideshow, 1);
        } else {
          cs.browseIndex = 0;
        }
        return;
      }

      if (cs.browsing) {
        if (isNext) {
          cs.browseIndex = (cs.browseIndex + 1) % slideCount;
        } else {
          cs.browseIndex = (cs.browseIndex - 1 + slideCount) % slideCount;
        }
        safeSelect(slideshow, cs.browseIndex);
        return;
      }
    }, true);
  }

  // ---- Featured Tees card setup (simpler — no slideshow, no arrows) ----
  function setupFeaturedCard(card) {
    var gallery = card.querySelector('.vp-featured-tees__media');
    if (!gallery) return;

    var href = card.getAttribute('href') || '';
    var handle = getHandleFromHref(href);
    if (!handle) return;

    var key = 'ft-' + handle;
    if (initialized[key]) return;
    initialized[key] = true;

    var cs = {
      gallery: gallery,
      cardContent: card,
      slideshow: null,
      hovered: false,
      browsing: false,
      browseIndex: 0,
      hoverGen: 0,
      videoStarting: false,
    };
    cardStates.push(cs);

    card.addEventListener('mouseenter', function () {
      // Reset any other card that might still be active
      for (var i = 0; i < cardStates.length; i++) {
        if (cardStates[i] !== cs && (cardStates[i].hovered || cardStates[i].browsing)) {
          forceHide(cardStates[i]);
          if (cardStates[i].slideshow && cardStates[i].browseIndex !== 0) {
            safeSelect(cardStates[i].slideshow, 0);
          }
        }
      }

      cs.hovered = true;
      startVideo(cs, handle);
    }, false);

    card.addEventListener('mouseleave', function () {
      forceHide(cs);
    }, false);

    card.addEventListener('mouseout', function (e) {
      if (!e.relatedTarget || !card.contains(e.relatedTarget)) {
        if (cs.hovered) {
          forceHide(cs);
        }
      }
    }, false);

    card.addEventListener('pointerleave', function (e) {
      if (e.pointerType !== 'mouse') return;
      if (e.relatedTarget && card.contains(e.relatedTarget)) return;
      if (cs.hovered) {
        forceHide(cs);
      }
    }, false);
  }

  function initAll() {
    var cards = document.querySelectorAll('.product-grid .product-card__content');
    for (var i = 0; i < cards.length; i++) setupCard(cards[i]);

    var ftCards = document.querySelectorAll('.vp-featured-tees__card');
    for (var i = 0; i < ftCards.length; i++) setupFeaturedCard(ftCards[i]);
  }

  function observeNewCards() {
    var grid = document.querySelector('.product-grid');
    if (!grid) return;
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          var cards = node.querySelectorAll
            ? node.querySelectorAll('.product-card__content') : [];
          for (var k = 0; k < cards.length; k++) {
            (function (c) { setTimeout(function () { setupCard(c); }, 100); })(cards[k]);
          }
          if (node.classList && node.classList.contains('product-card__content')) {
            (function (c) { setTimeout(function () { setupCard(c); }, 100); })(node);
          }
        }
      }
    }).observe(grid, { childList: true, subtree: true });
  }

  function boot() { initAll(); observeNewCards(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

// VP Tagline Rotator loader
if (!document.getElementById('vp-taglines-script')) {
  var _vpts = document.createElement('script');
  _vpts.id = 'vp-taglines-script';
  _vpts.src = (window.Shopify && window.Shopify.routes)
    ? window.Shopify.routes.root + 'cdn/shop/t/1/assets/vp-taglines.js'
    : '/cdn/shop/t/1/assets/vp-taglines.js';
  _vpts.defer = true;
  document.head.appendChild(_vpts);
}
